import { EditFinancialAdjustment } from 'features/Project/pages';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function FinancialAdjustmentEditPage() {
  return (
    <LayoutProvider>
      <Layout>
        <EditFinancialAdjustment />
      </Layout>
    </LayoutProvider>
  );
}

export default FinancialAdjustmentEditPage;
